import EventEmitter from "eventemitter3"

/* 跨頁全域變數 */
export class GlobalService extends EventEmitter {

  /* 網域位置 */
  Domain = window.location.protocol + "//" + window.location.hostname

  /* 是否是遊客狀態 */
  isGuest = null

  /* 消費者資料 */
  User = null

  /* 消費者瀏覽的店家資料，以及團購Token */
  Shop = null
  GroupToken = null

  /* 購物車內的商品內容 */
  Cart = []

  /* 團購訂單資料 */
  Groupbuy = []

  /* 訂單資料 */
  Order = null

  /* 好康頁面的瀏覽網頁高度*/
  AdvertisesScrollY = 0
  AdvertisesScrollElement = null

  /* ToastContent */
  ToastContent = null

  /* API */
  API = {
    /* 註冊 */
    REGISTER: {
      CREATED: "USER_CREATED",
      CREATE_FAILED: "USER_CREATE_FAILED",
      CAPTCHA_ERROR: "USER_CAPTCHA_ERROR"
    },
    /* 登入 */
    LOGIN: {
      LOGIN_SUCCESS: "LOGIN_SUCCESS",
      LOGINED: "LOGINED",
      NOT_LOGIN: "NOT_LOGIN",
      SUSPENDED: "WAS_SUSPENDED"
    },
    /* 消費者 */
    USER: {
      CAPTCHA_ERROR: "USER_CAPTCHA_ERROR",
      UPDATED: "USER_UPDATED",
      PASSWORD_NULL: "USER_PASSWORD_NULL",
      PASSWORD_FORMAT_ERROR: "USER_PASSWORD_FORMAT_ERROR",
      PHONE_FORMAT_ERROR: "USER_PHONE_FORMAT_ERROR",
      NOT_FOUND: "USER_NOT_FOUND",
    },
    /* 訂單 */
    ORDER: {
      CREATED: "ORDER_CREATED",
    }
  }

  /* 事件 */
  EVENT = {
    /* 確認消費者是否在線 */
    CHECK_USER_LOGIN: "CHECK_USER_LOGIN",
    /* 確認店家是否在線 */
    CHECK_SHOP_ONLINE: "CHECK_SHOP_ONLINE"
  }

  /* 訊息 */
  MESSAGE = {
    LOGIN: {
      NOT_LOGIN: "登入後才能進行此操作！",
      LOGIN_SUCCESS: "登入成功！為您跳轉頁面！",
      LOGIN_FAILED: "登入失敗",
      LOGINED: "您先前已登入！為您跳轉頁面！",
      SUSPENDED: "您的帳號已被停權！",
    },
    REGISTER: {
      REGISTER_SUCCESSED: "註冊成功！",
      CAPTCHA_ERROR: "手機驗證碼錯誤！",
      REGISTER_FAILED: "註冊失敗！",
      NAME_FORMAT_ERROR: "請輸入稱呼方式，不可超過四個字！",
      GENDER_NO_SELECT: "請選擇性別！",
      MAIL_ERROR: "請輸入正確的電子信箱！",
      PHONE_NULL: "您沒有輸入手機號碼！",
      PHONE_FORMAT_ERROR: "請輸入正確的手機號碼！",
      ADDRESS_CHAR_EXCEED: "外送地址不可超過三十二個字元！",
      SMS_COUNT_EXCEED: "今日已無法再使用簡訊認證"
    },
    USER: {
      PHONE_NULL: "您沒有輸入手機號碼！",
      PHONE_FORMAT_ERROR: "請輸入正確的手機號碼！",
      PASSWORD_NULL: "您沒有輸入密碼！",
      PASSWORD_FORMAT_ERROR: "密碼只能包含英文字母、數字與底線，長度需為 3 到 32 碼",
      CAPTCHA_ERROR: "手機驗證碼錯誤！",
      SMS_COUNT_EXCEED: "今日已無法再使用簡訊認證",
      UPDATED: "會員資料修改成功！",
      UPDATE_FAILED: "會員資料修改失敗！",
      NOT_LOGIN: "登入後才能進行此操作！",
      NOT_FOUND: "沒有此帳號！",
      NOT_FOUND_TO_REGISTER: "沒有此帳號！請先註冊！",
      LOGOUT_SUCCESS: "登出成功！為您跳轉頁面！"
    },
    SHOP: {
      NO_PREMISSIONS: "您沒有權限瀏覽此店家",
      CONTRACT_STOP: "此店家合約已到期，暫時無法提供服務"
    },
    CART: {
      SHOP_NOT_BUSINESS: "店家尚未營業",
      SHOP_ORDERSTATUS_PAUSED: "店家暫時下線",
      SHOP_ORDERSTATUS_DAYOFF: "店家公休",
      SHOP_ORDERSTATUS_NORMAL: "目前不在店家營業時間內，請於營業時間再試",
      SHOP_NOT_ONLINE: "店家準備中",
      SHOP_OFFLINE: "店家目前不在線，無法接單，請稍後再試",
      CART_NOTHING: "購物車沒有任何物品！",
      CART_PRICE_LESS_ZERO: "購物車價格小於零！",
      PRODUCT_NO_SALE: "購物車內有些商品已缺貨或停售，請刪除後再進行",
      DININGMODAL_NO_CHOOSE: "請選擇取餐方式！",
      SHOP_CLOSING: "店家即將打烊，訂單無法成立",
      TAKEMEALTIME_MISTAKE: "您的取餐時間有誤！<br>(不能小於店家的備餐時間)<br>將為您自動校正為",
      TAKEMEALTIME_MISTAKE_2: "您的取餐時間有誤！<br>(不能小於店家的備餐時間跟送餐時間)<br>將為您自動校正為",
      TAKEMEALTIME_NOT_IN_BUSINESS: "您選擇的時間不在店家的營業時間內，請重新確認取餐時間",
      INSIDE_CAPTCHA_ERROR: "內用驗證碼錯誤！",
      INSIDE_TABLE_NUMBER_EXCEED: "內用桌號不可以超過四個字！",
      INSIDE_TABLE_NUMBER_NULL: "請輸入內用桌號！",
      DELIVERY_PROMPT: "請輸入您想要外送的地址",
      DELIVERY_NULL: "請選擇正確的外送地址",
      DELIVERY_PRICE_NOT_REACH_STANDARD: "訂單價格未達到外送條件！",
      ORDER_CREATED: "訂單已送出！為您跳轉頁面！",
      ONLY_ALLOW_GUEST: "此店家僅允許遊客點餐，請登出後再試！",
    },
    GROUPBUY: {
      CREATEING: "團購已發起成功，為您自動跳轉頁面。<br>提醒發起人即是最後一位點餐者，<br>發起人送單前可改團購內容，<br>按「前往結帳」即送單給店家！",
      LOGIN_REQUIRED: "發起團購前請先登入"
    },
    LINEPAY: {
      PAYMENT_SUCCESS: "交易成功！為您跳轉畫面！",
      PAYMENT_FAILED: "交易失敗！幫您跳轉回結帳畫面！",
      JUMP_TO_PAYMENT: "幫您跳轉到金流付款畫面！"
    },
    ERROR: {
      MESSAGE: "發生異常錯誤，請稍後再試！",
    }
  }

  Alert = (Message) => {
    alert(Message)
    return false
  }

  emitToastContent = (content) => {
    this.emit("ToastContent", content)
  }
  
}

export const Global = new GlobalService()